import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface ErrorProps {
  message: string;
  showBackButton?: boolean;
  backButtonText?: string;
  onBackClick?: () => void;
}

const Error: React.FC<ErrorProps> = ({
  message,
  showBackButton = false,
  backButtonText = 'Back to Events',
  onBackClick,
}) => {
  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      window.location.href = '/events';
    }
  };

  return (
    <div className="py-6 sm:py-12">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-4 sm:p-6 lg:p-8 text-center border border-primary-500">
          <p className="text-lg text-primary-500">{message}</p>
          {showBackButton && (
            <button
              onClick={handleBackClick}
              className="mt-4 inline-flex items-center text-secondary-900 hover:opacity-80 transition-opacity duration-200 cursor-pointer"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              {backButtonText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Error;
